<template>
    <!-- 总容器 -->
    <div class="process-main-content">
        <!-- 左边容器 -->
        <div v-if="showLeftMenu" :class="leftContent">
            <div class="left-content">
                <!-- <el-tree :data="menuList" :props="defaultProps" @node-click="handleTreeNode"></el-tree> -->
                <el-tree
                    ref="menuTree"
                    highlight-current
                    node-key="id"
                    :current-node-key="selectNodeId"
                    :default-expanded-keys="['0']"
                    :expand-on-click-node="false"
                    :data="menuList"
                    :props="defaultProps"
                    @node-click="handleTreeNode">
                    <span class="custom-tree-node" slot-scope="{ node,menuList }">
                        <span><i :class="getTreeNodeClass(node)"></i>{{ node.label }}</span>
                    </span>
                </el-tree>
            </div>
        </div>
        <!-- 右边容器 -->
        <div :class="rightContent">
            <ProcessListView
                ref="workTaskRef"
                :key="loadTimer"
                :taskDefinitionKey="taskDefinitionKey"
                @initTaskMenu="getTaskMenuList"
                @setShowleftList="setShowleftList"
                @changeListMode="changeListMode"
            />
        </div>
    </div>
</template>
<script>
import { isEmpty } from 'lodash';
import ProcessListView from './ProcessListView';
import { mapActions } from 'vuex';
import * as constants from '@/common/constants';
import {
    getTaskMenuList
} from '@/data-model';
export default {
    components: {
        ProcessListView
    },
    data () {
        return {
            selectNodeId: '1',
            menuList: [],
            showLeftMenu: true,
            currentServiceId: '',
            taskDefinitionKey: '',
            loadTimer: '',
            leftContent: 'main-content-left-show',
            rightContent: 'right-content-show'
        };
    },
    computed: {
    },
    created () {
        this.loadTimer = new Date().getTime();
    },
    props: {
        defaultProps: { // 默认字段名配置
            type: Object
        }
    },
    watch: {
    },
    methods: {
        ...mapActions([
            constants.VUEX_ACTIONS_SIDEBAR_TOGGLE
        ]),
        handleToggleSideBar () {
            this[constants.VUEX_ACTIONS_SIDEBAR_TOGGLE]();
        },
        handleTreeNode (data, node, tree) {
            this.selectNodeId = data.id;
            // console.log(data);
            if (data.id === '0') { // 根节点
                return;
            }
            this.taskDefinitionKey = data.id;
            // this.loadTimer = new Date().getTime();
            setTimeout(() => {
                // 调用子组件的方法
                if (this.$refs.workTaskRef) {
                    this.$refs.workTaskRef.handleSearch(this.taskDefinitionKey);
                }
            }, 0);
        },
        async getTaskMenuList (param) {
            // console.log(param);
            if (isEmpty(param.processServiceId)) {
                return;
            }
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.currentServiceId = param.processServiceId;
            let tasks = await getTaskMenuList(this.currentServiceId);
            this.menuList = tasks;
            loading.close();
            // 刷新任务列表
            if (this.$refs.workTaskRef) {
                this.$refs.workTaskRef.handleSearch();
            }
        },
        setShowleftList (param) {
            // console.log(param);
            this.leftContent = 'main-content-left-show';
            this.rightContent = 'right-content-show';
            // this.showLeftMenu = param.showLeftMenu;
            // if (!this.showLeftMenu) {
            //     // 刷新任务列表
            //     if (this.$refs.workTaskRef) {
            //         this.$refs.workTaskRef.handleSearch();
            //     }
            //     return;
            // }
            this.getTaskMenuList(param);
        },
        changeListMode () {
            this.$emit('changeListMode');
            this.handleToggleSideBar();
        },
        getTreeNodeClass (node) {
            return node.data.treeIconClass;
        }
    }
};
</script>

<style lang="less">
.process-main-content {
    display: flex;
    width: 100%;
    .main-content-left-show {
        overflow-x: auto;
        .left-content {
            width: 238px;
            border: 1px solid #e6e6e6;
            height: 96%;
            overflow: auto;
			.element-sideEditor{
                height: auto;
				margin-bottom: 240px;
				position: relative;
			}
        }
        .el-menu {
            border-right: none;
        }
    }
    .main-content-left-close {
        overflow: auto;
        .left-content {
            border: 1px solid #e6e6e6;
            display: none;
        }
    }
    .right-content-show {
        width: calc(~'100% - 240px');
        .approve-model-content{
            padding-right: 2vw;
        }
        .bi-form{
            height: 100%;
            .BI-content{
               position: relative;
               width: 100%;
               height: ~"calc(100% - 30px)";
               .BI-area{
                   position: relative;
                   width: 100%;
                   height: 100%;
                   text-align: center;
                   .BI-area-one{
                       position: relative;
                       height: 100%;
                       .ve-histogram{
                          height: ~"calc(100% + 30px)" !important;
                       }
                   }
                   .is-justify-end{
                       margin-top: -12px;
                   }
               }
            }
        }
        .warehousing-model-content{
            height: 100%;
            .model-data-warehousing{
                height: 100%;
                overflow: auto;
                position: relative;
                .main-content-top{
                    display: none;
                }
                .main-content-center{
                    height: ~"calc(100% - 8px)";
                    overflow: auto;
                    margin-top: 4px;
                    margin-bottom: 4px;
                    background: #FFFFFF;
                    margin-left: 4px;
                    margin-right: 4px;
                    border-radius: 4px;
                    width: ~"calc(100% - 8px)";
                    overflow-x: hidden;
                    .vue-grid-layout{
                        height: 100%;
                        .vue-grid-item{
                            border: 1px solid #FFFFFF;
                            box-shadow: 0 1px 3px rgba(0,0,0,.35);
                            border-radius: 4px;
                            background-color: #FFFFFF;
                            .tool-bar{
                                width: 100%;
                                height: 30px;
                                line-height: 26px;
                                border-bottom: 1px solid #e0e0e0;
                                display: flex;
                                .tit{
                                    flex: 1;
                                    .grid-item-title{
                                        text-indent: 2em;
                                        border: none;
                                        height: 24px;
                                        outline: none;
                                        width: 80%;
										background: #FFFFFF;
                                    }
                                }
                                .tool-bar-opera{
                                    float: right;
                                    display: flex;
                                    padding-right:6px;
                                    .search-tool{
                                        cursor: pointer;
                                        width: 30px;
                                        text-align: center;
                                        height: 28px;
                                        line-height: 28px;
                                    }
                                    .search-tool{
                                        text-align: center;
                                      .icon-other-xuanzhong2x{
                                          font-size: 14px;
                                      }
                                    }
                                    .search-tool:hover{
                                       .icon-other-xuanzhong2x{
                                           color: #81d0f1;
                                       }
                                       .up-tool-group{
                                           display: block;
                                           z-index: 9999;
                                           position: relative;
                                       }
                                    }
                                }
                            }
                            .main-content{
                                width:100%;
                                height: ~"calc(100% - 30px)";
                                overflow: auto;
                            }
                            .main-content-body{
                                width:100%;
                                height: ~"calc(100% - 30px)";
                                overflow: auto;
                                .main-data-workplant{
                                    padding-bottom: 10px;
                                }
                                .main-content-search{
                                    border: 1px solid #F0F0F0;
                                    position: absolute;
                                    background-color: #FFFFFF;
                                    right: 0px;
                                    top: 0px;
                                    // right: -370px;
                                    width: 360px;
                                    height: 100%;
                                    z-index: 11;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                                    border-radius: 4px;
                                    .main-content-search-box{
                                        height: ~"calc(100% - 40px)";
                                        overflow: auto;
                                       .el-collapse-item__content{
                                           overflow: auto;
                                       }
                                    }
                                    .item-field-search-content-btn{
                                        text-align: right;
                                        height: 40px;
                                        line-height: 40px;
                                        padding-right: 10px;
                                    }
                                }
                                .BI-area{
                                    height: 100%;
                                }
                            }

                        }
                    }
                }
            }
      }
    }
    .right-content-close {
        width: 98%;
    }
    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        border-radius: 6px;
    }
    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background-color: rgb(222, 220, 220);
    }
}
.popAddModelDetail {
    .el-dialog__body {
        padding: 5px 30px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        height: ~"calc(100% - 8vh)";
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessTemplateMenuMode/ProcessTemplateMenuMode.vue